import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
    alertCreation: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    alertsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        marginTop: 20,
        marginBottom: 40
    },
    specialAlertsContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        marginBottom: 20
    },
    noResultsContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: 40,
        textAlign: 'center',
        maxWidth: 800,
        margin: '24px auto'
    }
}))
